import { useState, useEffect } from "react";

function CountdownTimer() {
  // Set the date to countdown to
  const targetDate = new Date("2026-05-31T13:00:00");

  // Calculate the time remaining until the target date
  const calculateTimeRemaining = () => {
    const now = new Date();
    const difference = targetDate.getTime() - now.getTime();
    const totalSeconds = Math.floor(difference / 1000);
    const days = Math.floor(totalSeconds / (60 * 60 * 24));
    const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    return {
      days,
      hours,
      minutes,
      seconds,
    };
  };

  // Set up state for the number of days remaining
  const [timeRemaining, setDaysRemaining] = useState(calculateTimeRemaining());

  // Update the state every second to show the current number of days remaining
  useEffect(() => {
    const intervalId = setInterval(() => {
      setDaysRemaining(calculateTimeRemaining());
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div class="countdown-banner">
      <p>TILL SHOTGUN START</p>
      <p>
        <span>
          {timeRemaining.days} <span className="sm">Days</span>{" "}
        </span>
        <span>
          {timeRemaining.hours} <span className="sm">Hours</span>{" "}
        </span>
        <span>
          {timeRemaining.minutes} <span className="sm">Minutes</span>{" "}
        </span>
        <span>
          {timeRemaining.seconds} <span className="sm">Seconds</span>
        </span>
      </p>
    </div>
  );
}

export default CountdownTimer;
